<div class="modal-header">
  <h4 class="modal-title"> {{'pasteArticlePopup.title' | translate}} </h4>
</div>
<div class="modal-body pt-0" *ngIf="isPresenterInitialized">
  <div class="modal-body-inner">
    <p>{{'pasteArticlePopup.message.insert_after_each_shortcut_note' | translate}}</p>
    <p>{{'pasteArticlePopup.label' | translate}}:</p>
    <div class="ps-5">
      <div class="form-check mb-2" *ngFor="let operation of operations">
        <input class="form-check-input" type="radio"
          name="pasteOperationsButtonGroup"
          id="{{operation.label}}"
          [value]="operation.action"
          [disabled]="operation.disabled"
          (change)="form.controls.currentPasteOperation.setValue(operation.action)"
          [checked]="form.controls.currentPasteOperation.value === operation.action">
        <label class="form-check-label" for="{{operation.label}}">{{operation.label | translate}}</label>
      </div>
    </div>
    <hr>
    <form [formGroup]="form">
      <div class="mb-3 row" *ngIf="configureArticleLength">
        <label class="col-md-3 col-form-label text-end font-weight-bold" for="pasteArticlesLengthInput">
          {{'pasteArticlePopup.label.length' | translate}}: *
        </label>
        <div class="col-md-4">
          <div class="input-group">
            <input class="form-control"
                   type="text"
                   spellcheck="false"
                   id="pasteArticlesLengthInput"
                   inputRestricter="^[0-9\.,]*$"
                   formControlName="pasteArticlesLength"
                   (inputEvent)="form.controls.pasteArticlesLength.setValue($event)"
                   [class.is-invalid]="form.controls.pasteArticlesLength.invalid">
            <div class="input-group-append">
              <span class="input-group-text">{{'global.unit.label.mm' | translate}}</span>
            </div>
            <div class="invalid-feedback">
              {{form.controls.pasteArticlesLength.errors?.messageKey | translate:{'0': form.controls.pasteArticlesLength.errors?.param} }}
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label text-end font-weight-bold" for="pasteArticlesDistanceInput">
          {{'pasteArticlePopup.label.distance' | translate}}: *
        </label>
        <div class="col-md-4">
          <div class="input-group">
            <input class="form-control"
                   type="text"
                   spellcheck="false"
                   id="pasteArticlesDistanceInput"
                   inputRestricter="^[0-9\.,]*$"
                   formControlName="pasteArticlesDistance"
                   (inputEvent)="form.controls.pasteArticlesDistance.setValue($event)"
                   [class.is-invalid]="form.controls.pasteArticlesDistance.invalid"
                   [readonly]="!isMoveArticleAllowed(null)">
            <div class="input-group-append">
              <span class="input-group-text">{{'global.unit.label.mm' | translate}}</span>
            </div>
            <div class="invalid-feedback">
              {{form.controls.pasteArticlesDistance.errors?.messageKey | translate:{'0': form.controls.pasteArticlesDistance.errors?.param} }}
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 row" *ngIf="showRepeatStepper && !isTypeCover">
        <label class="col-md-3 col-form-label text-end font-weight-bold" for="repeatStepper">
          {{'pasteArticlePopup.label.repeat_count' | translate}}:
        </label>
        <div class="col-md-4">
          <input class="form-control"
                 type="text"
                 spellcheck="false"
                 id="repeatStepper"
                 inputRestricter="^[0-9]{0,2}$"
                 (change)="repeatStepperCheck()"
                 formControlName="repeatStepper">
        </div>
      </div>
    </form>
    <div class="mb-3 row" *ngIf="configureLeadingMeasurement">
      <label class="col-md-3 col-form-label"></label>
      <div class="col-md-9 col-form-label">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="isLeadingValueCheckBox" [(ngModel)]="isLeadingValue">
          <label class="form-check-label" for="isLeadingValueCheckBox">{{'pasteArticlePopup.label.is_leading_value' | translate}}</label>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button id="step_forward" class="btn btn-primary btn-forward" appInputAutoFocus (click)="submit()" [disabled]="!isPresenterInitialized || !form.controls.currentPasteOperation.value">
    {{'global.label.next' | translate}}
  </button>
</div>
